import { RootState } from "../stores/app-store";
export const loggedInUserroleId = (state: RootState) => state.userRoleId
export const profile = (state: RootState) => state.Profile
export const secureDocsStatus = (state: RootState) => state.SecureDocsStatus
export const isMobileDevice = (state: RootState) => state.IsMobileDevice
export const User = (state: RootState) => state.User
export const isTeamsApp = (state: RootState) => state.IsTeamsApp
export const normalTextingUsage = (state: RootState) => state.PlanMetrics.NormalTextingUsage
export const loadingProfile = (state: RootState) => state.LoadingProfile;
export const showingAlert = (state: RootState) => state.ShowingAlertsCount > 0
export const planMetrics = (state: RootState) => state.PlanMetrics
export const deviceWidth = (state: RootState) => state.DeviceWidth
export const deviceHeight = (state: RootState) => state.DeviceHeight

export const plans = (state: RootState) => state.Plans

export const settings = (state: RootState) => state.Settings.Settings
export const isMassDeletionInProgress = (state: RootState) => state.IsMassContactsDeletionInProgress
export const users = (state: RootState) => state.Users
export const allUsers = (state: RootState) => state.AllUsers

export const showSideMenu = (state: RootState) => state.ShowSideMenu

export const roles = (state: RootState) => state.Roles

export const settingsObj = (state: RootState) => state.Settings
export const headerCount = (state: RootState) => state.HeaderCount
export const refreshHandler = (state: RootState) => state.RefreshHandler;
export const backHandler = (state: RootState) => state.BackHandler;
export const headerTitle = (state: RootState) => state.HeaderTitle;
export const toasts = (state: RootState) => state.Toasts;


export const isMassContactsDeletionInProgress = (state: RootState) => state.IsMassContactsDeletionInProgress;
export const isMassGroupsDeletionInProgress = (state: RootState) => state.IsMassGroupsDeletionInProgress;
export const handleMassContactsActionEvent = (state: RootState) => state.HandleMassContactsActionEvent;
export const handleMassGroupsActionEvent = (state: RootState) => state.HandleMassGroupsActionEvent;

export const WebNotificationText = (state: RootState) => state.WebNotificationText;
export const OrganizationName = (state: RootState) => state.OrganizationName;

export const PlanDetails = (state:RootState) => state.PlanDetails;

export const isDarkMode = (state: RootState) => state.isDarkMode;
export const isLoading = (state: RootState) => state.isLoading;
export const secureDocs = (state: RootState) => state.SecureDocs;

export const SysAdminAllOrganizations = (state: RootState) => state.SysAdminAllOrganizations;
export const SysAdminAllUsers = (state: RootState) => state.SysAdminAllUsers;

export const ISSmsLogin = (state: RootState) => state.ISSmsLogin;
export const IsNewOrganization = (state: RootState) => state.isNewOrganization;

export const SMSNotificationStatus = (state: RootState) => state.SmsNotificationStatus;
export const SmsUserDetails = (state: RootState) => state.SmsUserDetails;
